import * as React from 'react';

import * as styles from './styles.css';

export function LabelsLayout({ children }: React.PropsWithChildren<{}>) {
  return <div className={styles['labels-layout']}>{children}</div>;
}
